/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Pit3_DInputs */

const en_to_yaml_pit3_d = /** @type {(inputs: To_Yaml_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you took a commented YAML config, converted it to JSON somewhere, and are now converting back, the comments are already gone. JSON has no comment syntax, so they were dropped at the first conversion. Keep the original YAML if the comments matter.`)
};

const ko_to_yaml_pit3_d = /** @type {(inputs: To_Yaml_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주석이 달린 YAML 설정을 어디선가 JSON으로 바꾸고 지금 되돌리는 중이라면, 주석은 이미 사라졌습니다. JSON에는 주석 문법이 없으므로 첫 변환에서 버려졌습니다. 주석이 중요하다면 원래 YAML을 보관하세요.`)
};

const ja_to_yaml_pit3_d = /** @type {(inputs: To_Yaml_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント付きの YAML 設定をどこかで JSON に変換し、いま戻しているところなら、コメントはすでに失われています。JSON にはコメント構文がないので、最初の変換で落とされました。コメントが重要なら元の YAML を保管してください。`)
};

/**
* | output |
* | --- |
* | "If you took a commented YAML config, converted it to JSON somewhere, and are now converting back, the comments are already gone. JSON has no comment syntax, ..." |
*
* @param {To_Yaml_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_pit3_d = /** @type {((inputs?: To_Yaml_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_pit3_d(inputs)
	if (locale === "ko") return ko_to_yaml_pit3_d(inputs)
	return ja_to_yaml_pit3_d(inputs)
});